export default function minTranslate() {
  return -this.snapGrid[0];
}


//////////////////
// WEBPACK FOOTER
// /home/arkaitz/Proiektuak/mx-merkatari-elkartea/bedrock/web/app/themes/sage/node_modules/swiper/esm/components/core/translate/minTranslate.js
// module id = 37
// module chunks = 0